import styled, { css } from 'styled-components';
import { device } from '../breakpoints';
import { playGrey15 } from '../design-tokens';

export const StyledContentList = styled.section`
    position: relative;
    clear: both;
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    @media ${device.GteLarge} {
        margin-top: 45px;
    }

    ${(props) =>
        props.withDivider &&
        css`
            margin-top: 20px;
            border-bottom: 1px solid ${playGrey15};

            @media ${device.GteSmall} {
                margin-top: 35px;
            }
        `}

    ${(props) =>
        props.standalonde &&
        css`
            margin-bottom: 55px;
        `}

    ${(props) =>
        props.vtp &&
        css`
            margin: 30px 0 0;

            @media ${device.GteSmall} {
                margin-top: 40px;
            }

            @media ${device.GteMedium} {
                margin-top: 50px;
            }
        `}
`;

export const VideoList = styled.div`
    @media ${device.GteLarge} {
        overflow: visible;
    }

    ${(props) =>
        props.expanded &&
        css`
            padding-bottom: 20px;
        `}
`;

export const VideoListContainer = styled.div`
    max-width: 100%;
    width: 100%;
    position: relative;

    ${(props) =>
        !props.expanded &&
        css`
            padding-top: 50px;
            padding-bottom: 50px;
            top: -50px;
            margin-bottom: -100px;
        `}

    .no-touchevents & {
        overflow: visible;
    }
`;
